// extracted by mini-css-extract-plugin
export default {"breakpointPostContentAreaMin":"746px","breakpointPostContentAreaSmall":"900px","avatar":"niCLs","profileName":"tG2Lp","profile":"xXehp","search":"eTnrv"};